import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  BodyCopy,
  HeaderTwo,
  HeaderFour,
  HeaderSix,
} from 'secondstep-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 485px;
  background-color: ${themeGet('colors.white')};
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
  border-radius: 0.5rem;
  height: auto;

  ${themeGet('breakpoints.medium')} {
    width: auto;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${themeGet('colors.paleGray')};
  padding-bottom: 1.313rem;
  width: 100%;
`

export const HeaderTitle = styled(HeaderTwo)`
  margin: 0;
  line-height: 0;
  margin-bottom: -0.438rem;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 100%;
`

export const AngleButton = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.blueGray')};
  border-radius: 0.25rem;
  border: none;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  &:first-of-type {
    margin-right: 0.5rem;
  }

  &:hover:enabled {
    cursor: pointer;
    background-color: ${themeGet('colors.darkBlue')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  width: 100%;
  padding: 1.25rem;
`

export const ContentImage = styled.img`
  width: 10.375rem;
  margin-right: 1.25rem;
`

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: start;
  margin-top: -0.375rem;
`

export const CopyHeader = styled(HeaderFour)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  margin-bottom: 0.688rem;
`

export const CopySubhead = styled(HeaderSix)`
  font-size: 0.875rem;
  font-family: ${themeGet('font.molde.regular')};
  font-style: italic;
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 0.125rem;
`

export const CopyBody = styled(BodyCopy)`
  p:not(:last-child) {
    margin-block-end: 0;
  }
`
